import { createFileRoute } from '@tanstack/react-router';
import DripCampaignDetailPage from '../../views/dashboard-drip/campaigns/detail';

export const Route = createFileRoute('/dashboard/drip/campaigns_/$uuid')({
  component: DripCampaignDetailPage,
});
